import axios from 'axios';
import { BASE_URL, PRODUCT_SERVICE, CAPABILITIES, VERSION_1 } from './configuration';
import * as ACTION_TYPES from './ActionTypes';
import { PRODUCT_SERVICE_ENDPOINT } from './configuration/product-service';

export const PRODUCT_SERVICE_CAPABILITIES_URL = `${BASE_URL}/${PRODUCT_SERVICE}/${CAPABILITIES}/${VERSION_1}`;

export const getCatalogPublishableTenants = (
  catalogJobId,
  brand,
  provider,
  regionCode
) => {
  return async (dispatch) => {
    dispatch({
      type: ACTION_TYPES.SET_LOADER,
      payload: true
    });
    try {
      const response = await axios.get(
        `${PRODUCT_SERVICE_CAPABILITIES_URL}${PRODUCT_SERVICE_ENDPOINT.CATALOG_PUBLISHABLE_TENANTS}/${catalogJobId}`,
        {
          params: {
            brand: brand,
            provider: provider,
            regionCode: regionCode
          }
        }
      );
      dispatch({
        type: ACTION_TYPES.GET_TENANT_NAME,
        payload: response.data
      });
      dispatch({
        type: ACTION_TYPES.SET_LOADER,
        payload: false
      });
    } catch (error) {
      dispatch({
        type: 'ERROR',
        error: error
      });
      dispatch({
        type: ACTION_TYPES.SET_LOADER,
        payload: false
      });
    }
  };
};

export const changeCatalogStatus = (catalogJobId, stateChangePayload) => {
  return async (dispatch) => {
    dispatch({
      type: ACTION_TYPES.SET_LOADER,
      payload: true
    });
    try {
      await axios.patch(
        `${PRODUCT_SERVICE_CAPABILITIES_URL}${PRODUCT_SERVICE_ENDPOINT.CATALOG_WORFLOW}/${catalogJobId}`,
        stateChangePayload
      );
      dispatch({
        type: ACTION_TYPES.SET_LOADER,
        payload: false
      });
      return true;
    } catch (error) {
      dispatch({
        type: ACTION_TYPES.SET_LOADER,
        payload: false
      });
      const response = error.response;
      if (response !== undefined) {
        dispatch({
          type: 'PUBLISH_ERROR',
          error: response.data
        });
      } else {
        dispatch({
          type: 'ERROR',
          error: error
        });
      }
    }
  };
};
